import { frame } from "assets";
import styled from "styled-components";

export const CloseDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;
  padding: 1.5rem;

  img {
    cursor: pointer;
  }
`;

export const MainSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  @media (max-width: 990px) {
    padding: 2rem 1rem 12rem 1rem;
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 371px;
  height: 553.5px;

  @media (max-width: 990px) {
    width: 256.69px;
    height: 392.96px;
  }

  .innerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 767px) {
    margin-top: 3rem;
  }
`;

export const CardInnerDiv = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 1.2rem 1.7rem;

  @media (max-width: 990px) {
    padding: 1rem 1rem;
  }

  h1 {
    color: #fff;
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    margin-top: 1rem;

    @media (max-width: 990px) {
      font-size: 16.605px;
    }
  }

  .content-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.7rem;

    @media (max-width: 990px) {
      margin-top: 0.5rem;
    }
    h5 {
      color: #8e8c8c;
      font-family: "Inter" !important;
      font-size: 17.444px;
      font-style: italic;
      font-weight: 500;
      line-height: normal;
      margin: 0;

      @media (max-width: 990px) {
        font-size: 12.069px;
      }
    }

    p {
      text-align: right;
      font-family: "Inter" !important;
      font-size: 17.444px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      background: var(
        --yellow,
        linear-gradient(180deg, #e0c528 0%, #f7c13a 100%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0;

      @media (max-width: 990px) {
        font-size: 12.069px;
      }
    }
  }

  .mask1 {
    -webkit-mask-image: url(${frame});
    mask-image: url(${frame});
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
  }
`;

export const RightDiv = styled.div`
  h1 {
    color: var(--f-7-c-13-a, #f7c13a);
    font-size: 48px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 990px) {
      font-size: 24px;
      text-align: center;
      margin-top: -2rem;
    }
  }
`;

export const Step1 = styled.div`
  .step1-div {
    display: flex;
    align-items: center;
    gap: 5rem;

    @media (max-width: 990px) {
      gap: 2rem;
      margin-top: 1.5rem;
    }
  }

  h1 {
    color: #f7c13a;
    font-size: 128px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    margin: 0;

    @media (max-width: 990px) {
      font-size: 70.318px;
    }
  }

  .coonect-div {
    h5 {
      color: #f7c13a;
      font-size: 27.5px;
      font-style: italic;
      font-weight: 600;
      letter-spacing: -0.48px;
      text-transform: uppercase;
      @media (max-width: 990px) {
        font-size: 18px;
      }
    }
  }

  .connect-text {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;

    @media (max-width: 990px) {
      gap: 0.5rem;
      margin-top: 0.5rem;
      img {
        width: 23.759px;
        height: 22.79px;
      }
    }

    h1 {
      color: #fff;
      font-size: 32.905px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin: 0;

      @media (max-width: 990px) {
        font-size: 20px;
      }
    }
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-top: 1rem;

    @media (max-width: 990px) {
      width: 188.633px;
      height: 30.002px;
      margin-top: 0.5rem;
    }
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: #331d01;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;

      @media (max-width: 990px) {
        font-size: 14px;
      }

      @media (max-width: 990px) {
        img {
          width: 14.283px;
          height: 14.283px;
        }
      }
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .divider-img {
    margin-top: -1rem;
    img {
      width: 100%;
    }
  }
`;

export const Step2 = styled.div`
  margin-top: -1.5rem;
  @media (max-width: 990px) {
    margin-top: -1rem;
  }

  &.opacity-low {
    opacity: 0.3;
  }

  &.opacity-full {
    opacity: 1;
  }

  .connect-text {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;

    @media (max-width: 990px) {
      gap: 0.5rem;
      img {
        width: 22.234px;
        height: 21.326px;
      }
    }

    h1 {
      color: #fff !important;
      font-size: 32.905px !important;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin: 0;

      @media (max-width: 990px) {
        font-size: 20px !important;
      }
    }
  }

  .step1-div {
    display: flex;
    align-items: center;
    gap: 3rem;
    @media (max-width: 990px) {
      gap: 1.2rem;
      align-items: start;
    }
  }
  h1 {
    color: #f7c13a;
    font-size: 128px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    margin: 0;

    @media (max-width: 990px) {
      font-size: 70.318px;
    }
  }

  .coonect-div {
    margin-top: 1.5rem;
    h5 {
      color: #f7c13a;
      font-size: 27.5px;
      font-style: italic;
      font-weight: 600;
      letter-spacing: -0.48px;
      text-transform: uppercase;
      @media (max-width: 990px) {
        font-size: 18px;
      }

      @media (max-width: 767px) {
        width: 14rem;
      }

      @media (max-width: 990px) {
        img {
          /* width: 74px;
          height: 10px; */
        }
      }
    }

    p {
      color: #fff;
      font-family: "Inter" !important;
      font-size: 14px;
      font-style: italic;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
      margin-top: 1.3rem;

      @media (max-width: 990px) {
        font-size: 12px;
        margin-top: 0.5rem;
      }
    }
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-top: 0.7rem;

    @media (max-width: 990px) {
      width: 150.5px;
      height: 30.002px;
      margin-top: 0.2rem;
    }
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: #331d01;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .step2-div {
    p {
      color: #ffd764;
      font-family: "Inter";
      font-size: 15.225px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 0;
      margin-top: 0.5rem;
      display: flex;
      align-items: center;
      gap: 0.3rem;

      @media (max-width: 767px) {
        font-size: 12px;
      }
    }

    h4 {
      color: #fff;
      font-size: 16px;
      font-style: italic;
      font-weight: 700;
      line-height: 136.8%; /* 21.888px */
      letter-spacing: 0.96px;
      margin-top: 0.5rem;

      @media (max-width: 767px) {
        font-size: 13px;
      }
    }

    h3 {
      color: #fff;
      font-size: 16px;
      font-style: italic;
      font-weight: 300;
      letter-spacing: 0.96px;
      margin-top: -0.3rem;
      span {
        text-decoration-line: underline;
      }

      @media (max-width: 767px) {
        font-size: 13px;
      }
    }
  }
`;

export const Step3 = styled.div`
  margin-top: -1.5rem;
  @media (max-width: 990px) {
    margin-top: 1.5rem;
    padding-bottom: 1rem;
  }

  &.opacity-low {
    opacity: 0.3;
  }

  &.opacity-full {
    opacity: 1;
  }
  .step3-div {
    display: flex;
    align-items: center;
    gap: 3rem;

    @media (max-width: 990px) {
      gap: 1.2rem;
    }
  }

  h1 {
    color: #f7c13a;
    font-size: 128px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 990px) {
      font-size: 70.318px;
    }
  }

  .start-div {
    h5 {
      color: #f7c13a;
      font-size: 27.5px;
      font-style: italic;
      font-weight: 600;
      letter-spacing: -0.48px;
      text-transform: uppercase;
      @media (max-width: 990px) {
        font-size: 18px;
        margin-top: -1.5rem;
      }
    }
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 182.5px;
    height: 46px;
    margin-top: 1rem;

    @media (max-width: 990px) {
      width: 148.5px;
      height: 30.002px;
      margin-top: 0.5rem;
    }
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: #331d01;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;

      @media (max-width: 990px) {
        margin-top: 0rem !important;
      }
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  gap: 4rem;
  position: relative;
  padding: 3rem 2rem 0rem 3rem;

  @media (max-width: 990px) {
    display: flex;
    flex-direction: column;
    padding: 0rem 1rem 0rem 1rem;

    .card-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 990px) {
        margin-top: -1rem;
      }
    }
  }
`;

export const MainDiv = styled.div`
  position: relative;
  width: 1193.928px;
  height: 659.651px;

  @media (max-width: 990px) {
    width: 100%;
    height: 100%;
  }

  .maininnerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    @media (max-width: 990px) {
      display: none;
    }
  }

  .maininnerimg2 {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    @media (min-width: 990px) {
      display: none;
    }
  }
`;

export const FirstDiv = styled.div`
  display: flex;
  gap: 3rem;
  align-items: center;
  margin-top: 2rem;

  @media (max-width: 990px) {
    gap: 1rem;
    margin-top: -2rem;
  }
  h1 {
    color: #f7c13a;
    font-size: 128px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 990px) {
      font-size: 70.318px;
    }
  }

  .first-div {
    h1 {
      color: #f7c13a;
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 77.247px; /* 321.862% */
      letter-spacing: -0.48px;
      margin: 0;

      @media (max-width: 990px) {
        font-size: 14px;
      }
    }

    p {
      color: #fff;
      font-family: "Inter";
      font-size: 16px;
      font-style: italic;
      font-weight: 500;
      line-height: 136.8%; /* 21.888px */
      letter-spacing: 0.96px;
      margin-top: 0.5rem;
      margin-bottom: 0rem;
      @media (max-width: 990px) {
        font-size: 13px;
      }
    }
  }
`;

export const SecondDiv = styled.div`
  .second-div {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    justify-content: space-between;
    h5 {
      color: #fff;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin: 0;

      @media (max-width: 990px) {
        font-size: 20px;
      }
    }

    p {
      color: #fff;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      margin: 0;
      text-align: end;

      @media (max-width: 990px) {
        font-size: 20px;
      }
    }
  }

  .total-div {
    display: flex;
    align-items: center;
    margin-top: 0.4rem;
    justify-content: space-between;
    h5 {
      color: #f7c13a;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 700;
      line-height: normal;
      margin: 0;
      @media (max-width: 990px) {
        font-size: 20px;
      }
    }

    p {
      color: #f7c13a;
      font-family: "Inter";
      font-size: 26px;
      font-style: italic;
      font-weight: 700;
      line-height: normal;
      margin: 0;
      @media (max-width: 990px) {
        font-size: 20px;
      }
    }
  }
`;

export const BtnDiv = styled.div`
  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-top: 3rem;
    display: block;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 990px) {
      width: 170px;
      height: 30.002px;
      margin-top: 1rem;
      margin-bottom: 2rem;
    }
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: #331d01;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const MintWrapper = styled.div`
  margin-left: 8rem;
  width: 28rem;

  @media (max-width: 990px) {
    margin-left: 0rem;
    width: 100%;
  }
`;

export const SuccessDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 2rem;

  @media (max-width: 990px) {
    gap: 0.7rem;
    margin-top: 0rem;
    img {
      width: 22.224px;
      height: 21.317px;
    }
  }
  h1 {
    color: #f7c13a;
    font-size: 40px;
    font-style: italic;
    font-weight: 400;
    line-height: 116.755px; /* 291.887% */
    letter-spacing: -0.8px;

    @media (max-width: 990px) {
      font-size: 24px;
    }
  }
`;

export const MessageDiv = styled.div`
  h5 {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: italic;
    font-weight: 700;
    line-height: 136.8%; /* 21.888px */
    letter-spacing: 0.96px;
    margin-top: 1.5rem;

    @media (max-width: 990px) {
      margin-top: 0.8rem;
    }
  }

  p {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
    line-height: 136.8%;
    letter-spacing: 0.96px;
    margin-top: 1.5rem;

    @media (max-width: 990px) {
      font-size: 13px;
    }
  }
`;

export const ImgDiv = styled.div`
  margin-top: 3.5rem;
  display: flex;
  gap: 2.5rem;

  @media (max-width: 990px) {
    margin-top: 1rem;
    img {
      width: 140.407px;
      height: 36.285px;
    }
  }
`;

export const MainMintSection = styled.section`
  .third-img {
    margin-top: 2.5rem;
  }
  @media (max-width: 990px) {
    .third-img {
      width: 140.407px;
      height: 36.285px;
      margin-top: 1.3rem;
      margin-bottom: 2rem;
    }
  }
`;
